<button
  pButton
  (click)="isMenuLogoutOpen = false; confirmationPopup()"
  icon="pi pi-sign-out"
  class="rounded-md border-none bg-white text-darkest w-full text-center 2xl:flex hidden justify-center"></button>
<button
  pButton
  [label]="'logout.title' | translate"
  (click)="isMenuLogoutOpen = false; confirmationPopup()"
  icon="pi pi-sign-out"
  class="rounded-md space-x-2 border-none bg-white text-darkest text-center 2xl:hidden flex justify-center"></button>

<p-confirmDialog
  [closable]="false"
  #cd
  [draggable]="false"
  [style]="{ width: '40rem' }">
  <ng-template pTemplate="header">
    <div class="flex p-4 bg-lightest rounded-md w-full">
      <h1 class="font-app-bold text-2xl text-darkest text-center mx-auto">
        {{ "logout.title" | translate }}
      </h1>
    </div>
  </ng-template>

  <ng-template
    pTemplate="message"
    let-message>
    <div class="flex mx-auto">
      <p class="font-app-regular text-lg text-darkest p-4">
        {{ "logout.message" | translate }}
      </p>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-around pb-5 w-full">
      <button
        pButton
        label="Non"
        class="rounded-md p-3 mt-2 border-primary border-solid border-2 bg-white text-primary text-center w-full"
        (click)="cd.reject()"></button>
      <button
        pButton
        label="Oui"
        class="rounded-md p-3 mt-2 ml-3 border-primary border-solid border-2 bg-primary text-white text-center w-full"
        (click)="cd.accept()"></button>
    </div>
  </ng-template>
</p-confirmDialog>

